import styled from 'styled-components';

export const StyledFirstBattle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1rem;
  width: 20rem;
  padding: ${({ $withpadding }) => $withpadding ? '3rem' : '0'};
  padding-top: 3rem;
  padding-bottom: 3rem;
  box-sizing: content-box;
`;

export const FirstBattleText = styled.div`
  color: white;
  font-family: "BebasNeue";
  text-transform: uppercase;
  font-size: 2rem;
`;

export const FirstBattleBroadsideLogo = styled.img`
  width: 100%;
`;

export const FirstBattleModeLogo = styled.img`
  width: 100%;
`;

